
const digest = 'd0d0a28f915aaeb9b9777debea7d429c0a8a2dce6c44b7c7cff6a502d4245745';
const classes = {"wrapper":"_wrapper_1yhi5_1","leftSide":"_leftSide_1yhi5_9","image":"_image_1yhi5_16","content":"_content_1yhi5_22","name":"_name_1yhi5_27","rightSide":"_rightSide_1yhi5_32","badgeWrapper":"_badgeWrapper_1yhi5_40"};
const css = `._wrapper_1yhi5_1 {
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
  border: 1px solid #d1d4da;
  border-radius: 3px;
  cursor: pointer;
}
._wrapper_1yhi5_1 ._leftSide_1yhi5_9 {
  padding: 12px 24px;
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
}
._wrapper_1yhi5_1 ._leftSide_1yhi5_9 ._image_1yhi5_16 img {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  object-fit: cover;
}
._wrapper_1yhi5_1 ._leftSide_1yhi5_9 ._content_1yhi5_22 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
._wrapper_1yhi5_1 ._leftSide_1yhi5_9 ._content_1yhi5_22 ._name_1yhi5_27 {
  font-size: 14px;
  font-weight: 600;
  text-decoration: underline;
}
._wrapper_1yhi5_1 ._rightSide_1yhi5_32 {
  padding: 12px 24px;
  flex-grow: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
._wrapper_1yhi5_1 ._rightSide_1yhi5_32 ._badgeWrapper_1yhi5_40 {
  position: absolute;
  right: 24px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: flex-end;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  